import getProductTypeValues from "./getProductTypeValues";

// Whether a product has the given type. A product can have multiple types, for example a physical
// product that also gives access to a course.
function productHasType(product, type) {
    return getProductTypeValues(product).includes(type);
}

export default productHasType;
